import { IMenuByTypesItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';

import Accordion from '~/src/features/_layout/Header/mobile/components/Accordion';
import Category from '~/src/features/_layout/Header/mobile/components/Category';

import * as ST from './styled';

interface IProps {
    menuItems: IMenuByTypesItem[],
    onClick: (item: string, menuType?: string) => void,
    clickHandler?: () => void,
}

const CardMenu = ({
    menuItems,
    onClick,
    clickHandler,
}: IProps): JSX.Element => {
    return (
        <ST.MainMenuWrapper>
            {menuItems.map(item => (
                <Accordion
                    key={item.id}
                    title={item.title}
                    link={item.link ? item.link : ''}
                    isAvailable={!!item.available}
                    isVisible={item?.children[0]?.children?.length > 1 || item?.children?.length > 1 || false}
                    isPromoted={!!item.promoted}
                    onClick={onClick}
                    firstItem={menuItems[0]}
                >
                    <Category
                        item={item}
                        onClick={onClick}
                        clickHandler={clickHandler}
                        isPromoted={!!item.promoted}
                    />
                </Accordion>
            ))}
        </ST.MainMenuWrapper>
    );
};

export default CardMenu;
